<script>
export default {
  computed: {
    article () {
      return this.docs.story['introduction']
    }
  }
}
</script>

<template>
  <div class="gp-story-article transition-item">
    <article>
      <header
        class="is-size-0 is-size-1-mobile has-text-weight-bold"
        v-html="article.description"
      ></header>
      <div
        class="text is-size-4 is-size-5-mobile"
        v-html="article.text"
      ></div>
    </article>
  </div>
</template>

<style lang="scss" scoped>
article {
  padding: 2.5rem .5rem;
}
header {
  margin-bottom: 1.5rem;
  line-height: 2.5rem;
}
.text {
  line-height: 1.75rem;
}
@include is-mobile {
  article {
    padding: 1.5rem;
    header {
      margin: 0;
      margin-bottom: 1.5rem;
      line-height: 1.75rem;
    }
    .text {
      line-height: 1.375rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/story/story-introduction.vue